import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import cnames from 'classnames'
import { useHistory } from 'react-router-dom'
import { buildReservationKey } from 'Utils/reservation'
import { formatDate } from 'Utils/Dates'
import { Button } from 'reactstrap'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import Reservation from 'Checkout/Components/Cart/Reservation'

const Reservations = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const loadingReference = useRef()
  const { accommodation, checkIn, checkOut, siteType } = useSelector(state => state.search)
  const isLoading = useSelector(state => state.cart.pricing.loading)
  const reservations = useSelector(state => state.cart.pricing.data.reservations)
  const classesWrapper = cnames('reservations d-flex flex-column gap-3', { 'skeleton-loading': loading })

  useEffect(() => {
    if (isLoading) loadingReference.current = true
    if (!isLoading && loadingReference.current) setLoading(false)
  }, [isLoading])

  const addReservation = () => {
    const checkInFormatted = formatDate(checkIn)
    const checkOutFormatted = formatDate(checkOut)
    const { type } = siteType
    const datesParams = `check_in=${checkInFormatted}&check_out=${checkOutFormatted}`
    const url = `/search?accommodation=${accommodation}&${datesParams}&site_type=${type}`
    history.push(url)
  }

  return (
    <div className={classesWrapper}>
      {reservations.map((reservation, index) => (
        <Reservation key={buildReservationKey(index, reservation)} reservation={reservation} />
      ))}

      <Button className="d-flex flex-column align-items-center gap-1 py-2" color="dashed-outline-blue"
              onClick={addReservation}>
        <FontAwesomeIcon icon="circle-plus" className="me-1" />

        Add Reservation
      </Button>
    </div>
  )
}

export default Reservations
